import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { flexbox, height, margin, width } from 'styled-system';

import useTranslation from 'hooks/use-translation';

import ApiLayerSVG from 'assets/marketing/dutchie-plus/api-layer';
import DataLayerSVG from 'assets/marketing/dutchie-plus/data-layer';
import WebsiteLayerSVG from 'assets/marketing/dutchie-plus/website-layer';

import { DesktopOnly, MobileOnly } from 'shared/components';
import Navigation from 'marketing/components/marketing-navigation';
import Hero from '../../components/hero';
import StackedSlider from '../../components/stacked-slider';

export default function Header() {
  const { t } = useTranslation();
  const [animationLayer, setAnimationLayer] = useState(-1);
  const [contentLayer, setContentLayer] = useState(0);
  const content = [
    {
      title: t('dutchiePlus.designCustomExperience', 'Design a completely custom e-commerce experience.'),
      label: t('dutchiePlus.yourDesign', 'Your design'),
      description: t(
        'dutchiePlus.sittingOnTop',
        // eslint-disable-next-line max-len
        'Sitting on top is a completely custom menu experience with your design and user experience. No limitations. No restrictions.'
      ),
    },
    {
      title: t('dutchiePlus.rockSolidAPI', 'A rock solid API Layer, designed specifically for developers.'),
      label: t('dutchiePlus.developerFirstAPI', 'A DEVELOPER FIRST API'),
      description: t(
        'dutchiePlus.weBuiltTheMostFlexible',
        // eslint-disable-next-line max-len
        'We’ve built the most flexible and robust API layer in cannabis e-commerce, designed specifically to be enjoyed by developers.'
      ),
    },
    {
      title: t('dutchiePlus.cleanSanitizedData', 'Clean, sanitized data, pulled directly from your point of sale.'),
      label: t('dutchiePlus.developerFirstAPI', 'A CLEAN DATA LAYER'),
      description: t(
        'dutchiePlus.advancedIntegrations',
        // eslint-disable-next-line max-len
        'Advanced integrations with your point of sale create a foundation of clean, sanitized data to build your menu on.'
      ),
    },
  ];
  const ref = useRef();
  return (
    <Container ref={ref}>
      <NavContainer>
        <StyledDesktopOnly display='flex'>
          <Column width='50%' justifyContent='flex-start'>
            <Navigation variant='plus' />
          </Column>
        </StyledDesktopOnly>
      </NavContainer>
      <Row>
        <Hero />
      </Row>
      <Row height={700} mb={500} className='scroller'>
        <SliderContainer>
          <StackedSlider
            animationLayer={animationLayer}
            contentLayer={contentLayer}
            content={content}
            layers={[WebsiteLayerSVG, ApiLayerSVG, DataLayerSVG]}
            onChange={setContentLayer}
            onChangeAnimation={setAnimationLayer}
          />
        </SliderContainer>
      </Row>
    </Container>
  );
}

const Column = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${flexbox}
  ${width};
`;

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.dutchiePlusBlue[10]};
  padding-bottom: 250px;
  padding: 0 120px;
  /* overflow: hidden; */
  .pin-spacer {
    /* max-height: 935px !important; */
  }
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    padding: 0;
  }
`;

const NavContainer = styled.div`
  display: flex;
  padding: 40px 0px;
  nav {
    svg {
      margin-right: 10px;
    }
    ${({ theme }) => theme.breakpoints.up(`sm`)} {
      margin-left: -29px;
    }
  }
  .button-container {
    margin-right: 0;
  }
  ul {
    padding: 0;
  }
  a {
    font-size: 15px;
    line-height: 15px;
    &:hover {
      text-decoration: underline;
    }
  }
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    padding: 45px 0;
  }
`;

const Row = styled.div`
  display: flex;
  margin: 0 60px;
  ${height};
  ${margin};
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    margin: 0 auto;
    height: 100%;
    width: 100%;
    &.active {
      top: 0 !important;
    }
  }
`;

const SliderContainer = styled.div`
  height: 100%;
  width: 100%;
  margin: 0 0 0 25px;
`;

const LoginButtonContainer = styled.div`
  button {
    font-size: 15px;
    line-height: 17px;
    background: transparent;
    margin-right: 30px;
    text-transform: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const ScheduleDemoButtonContainer = styled.div`
  button {
    font-size: 15px;
    line-height: 17px;
    background: ${({ theme }) => theme.colors.dutchiePlusGreen[35]};
    height: 45px;
    width: 158px;
    text-transform: none;
    border-radius: 100px;
    /* padding: 20px 0; */
  }
`;

const StyledDesktopOnly = styled(DesktopOnly)`
  width: 100%;
`;

const StyledMobileOnly = styled(MobileOnly)`
  width: 100%;
  .MuiDrawer-paper {
    height: 256px;
  }
`;
